module.exports = __webpack_public_path__ + "img/icon-movie-white.b97e2269.svg";